module.exports = __webpack_public_path__ + "img/circle_digital marketing.1a4bebab.svg";